// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/product/product.proto" (package "mlmbox.client.product", syntax proto3)
// tslint:disable
import { Invoice_VerifiedResponse } from "../../types/product.ts";
import { Invoice_PreviewResponse } from "../../types/product.ts";
import { Invoice_Request } from "../../types/product.ts";
import { AiLinkResponse } from "../../types/product.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
/**
 * @generated ServiceType for protobuf service mlmbox.client.product.Product
 */
export const Product = new ServiceType("mlmbox.client.product.Product", [
    { name: "GetAiLink", options: {}, I: Empty, O: AiLinkResponse },
    { name: "PreviewPurchase", options: {}, I: Invoice_Request, O: Invoice_PreviewResponse },
    { name: "VerifiedPurchase", options: {}, I: Invoice_Request, O: Invoice_VerifiedResponse }
]);
